import "./styles/vendors.css";
import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { EnvProvider } from "./contexts/EnvContext";
import WrapperProvider from "./contexts/WrapperProvider";
import "best-common-react/styles/bcr-core.css";
import "best-common-react/styles/bcr-fonts-vendor.css";

const container = document.getElementById("requestix-ui");
const root = createRoot(container!);

root.render(
  <EnvProvider>
    <WrapperProvider>
      <App />
    </WrapperProvider>
  </EnvProvider>,
);
